import { configureStore } from '@reduxjs/toolkit';
import { logger } from 'redux-logger';
import thunk from 'redux-thunk';

import allReducers from './reducers';
import initialState from './reducers/initialState';

const middleware = [thunk, logger];

// TODO passer sur du typpé
export const reduxStore = configureStore ({
  reducer: allReducers,
  middleware: middleware,
  preloadedState: initialState,
  devTools: true
})
